webpackJsonp([114276838955818,60335399758886],{

/***/ 94:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(174);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(94);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, menu, nav, section {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol, ul {\n  list-style: none;\n}\nblockquote, q {\n  quotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: \'\';\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n'], ['\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, menu, nav, section {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol, ul {\n  list-style: none;\n}\nblockquote, q {\n  quotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: \'\';\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n']);
	
	var _styledComponents = __webpack_require__(3);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var reset = (0, _styledComponents.css)(_templateObject);
	
	exports.default = reset;

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailMe = function EmailMe(_ref) {
	  var className = _ref.className,
	      text = _ref.text;
	  return _react2.default.createElement(
	    "a",
	    { className: className, rel: "noopener", href: "mailto:simon@borrowedverse.com" },
	    text
	  );
	};
	
	EmailMe.propTypes = {
	  className: _propTypes2.default.string,
	  text: _propTypes2.default.string.isRequired
	};
	
	EmailMe.defaultProps = {
	  className: ""
	};
	
	exports.default = EmailMe;
	module.exports = exports["default"];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    _style.Wrapper,
	    null,
	    _react2.default.createElement(
	      _style.Item,
	      { position: 'left' },
	      'Nausicaa'
	    ),
	    _react2.default.createElement(
	      _style.Item,
	      { position: 'right' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'P.I. 03671100984\xA0-\xA0'
	      ),
	      _react2.default.createElement(
	        'a',
	        { target: '_blank', rel: 'noopener noreferrer', href: 'https://github.com/nausicaa/nausicaa.com.au' },
	        'Source code'
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Item = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  position: fixed;\n  top: 50%;\n  ', '\n'], ['\n  width: 100%;\n  position: fixed;\n  top: 50%;\n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    position: static;\n    padding-top: 1.5rem;\n  '], ['\n    position: static;\n    padding-top: 1.5rem;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  font-family: ', ';\n  color: ', ';\n  font-size: .85rem;\n  line-height: 1em;\n  ', '\n  \n  ', '\n'], ['\n  position: absolute;\n  font-family: ', ';\n  color: ', ';\n  font-size: .85rem;\n  line-height: 1em;\n  ', '\n  \n  ', '\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n      transform: rotate(-90deg) translateX(-50%);\n      transform-origin: left;\n      ', '\n    '], ['\n      transform: rotate(-90deg) translateX(-50%);\n      transform-origin: left;\n      ', '\n    ']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n      transform: rotate(90deg) translateX(50%);\n      transform-origin: right;\n      ', '\n    '], ['\n      transform: rotate(90deg) translateX(50%);\n      transform-origin: right;\n      ', '\n    ']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n    position: static;\n    transform: rotate(0) translateX(0);\n    transform-origin: 0;\n    padding: .5rem 0 0;\n    text-align: center;\n    font-size: .8rem;\n  '], ['\n    position: static;\n    transform: rotate(0) translateX(0);\n    transform-origin: 0;\n    padding: .5rem 0 0;\n    text-align: center;\n    font-size: .8rem;\n  ']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.footer(_templateObject, _constants.media.md(_templateObject2));
	
	var Item = exports.Item = _styledComponents2.default.div(_templateObject3, _constants.fonts.mono, _constants.colors.gray700, function (props) {
	  return props.position === 'left' ? (0, _styledComponents.css)(_templateObject4, (0, _constants.getOuterSpace)('left')) : (0, _styledComponents.css)(_templateObject5, (0, _constants.getOuterSpace)('right'));
	}, _constants.media.md(_templateObject6));

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	
	function Circle (props) {
	    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Oval"),React.createElement("path",{"d":"M11 21.5C5.201 21.5.5 16.799.5 11S5.201.5 11 .5 21.5 5.201 21.5 11 16.799 21.5 11 21.5zm0-1a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19z","fill":"#FFF","key":1})]);
	}
	
	Circle.displayName = "Circle";
	
	Circle.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};
	
	module.exports = Circle;
	
	Circle.default = Circle;


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(52);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _circle = __webpack_require__(368);
	
	var _circle2 = _interopRequireDefault(_circle);
	
	var _style = __webpack_require__(155);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	  return _react2.default.createElement(
	    _style.Wrapper,
	    null,
	    _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/" },
	        _react2.default.createElement(
	          "div",
	          { className: "logo" },
	          _react2.default.createElement(
	            "span",
	            { className: "spaced" },
	            "N"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "spaced" },
	            "a"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "spaced" },
	            "u"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "spaced" },
	            "s"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "spaced" },
	            "i"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "spaced" },
	            "c"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "spaced" },
	            "a"
	          ),
	          _react2.default.createElement(
	            "span",
	            { className: "spaced" },
	            "\xE4"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Logo;
	module.exports = exports["default"];

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  ", "\n  ", "\n\n  > div {\n    position: relative;\n  }\n\n  a,\n  svg {\n    display: block;\n  }\n\n  a {\n  }\n\n  svg {\n    width: 100%;\n    height: auto;\n  }\n\n  .circle {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) scale(0);\n    background: rgba(255, 255, 255, 0.05);\n    height: 100%;\n    width: 100%;\n    border-radius: 100%;\n    pointer-events: none;\n    opacity: 1;\n    will-change: transform;\n  }\n\n  .logo {\n    display: flex;\n    justify-content: space-between;\n    text-transform: uppercase;\n    font-weight: 200;\n    font-size: 10rem;\n    line-height: 1;\n    color: ", ";\n    width: 40vw;\n    max-width: 40rem;\n    font-family: ", ";\n\n    ", "\n  }\n\n  .spaced {\n  }\n\n  a:hover + .circle {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(7.5);\n    transition:\n      transform 1s cubic-bezier(0.45, 0, 0.1, 1),\n      opacity 0.8s ease;\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  ", "\n  ", "\n\n  > div {\n    position: relative;\n  }\n\n  a,\n  svg {\n    display: block;\n  }\n\n  a {\n  }\n\n  svg {\n    width: 100%;\n    height: auto;\n  }\n\n  .circle {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) scale(0);\n    background: rgba(255, 255, 255, 0.05);\n    height: 100%;\n    width: 100%;\n    border-radius: 100%;\n    pointer-events: none;\n    opacity: 1;\n    will-change: transform;\n  }\n\n  .logo {\n    display: flex;\n    justify-content: space-between;\n    text-transform: uppercase;\n    font-weight: 200;\n    font-size: 10rem;\n    line-height: 1;\n    color: ", ";\n    width: 40vw;\n    max-width: 40rem;\n    font-family: ", ";\n\n    ", "\n  }\n\n  .spaced {\n  }\n\n  a:hover + .circle {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(7.5);\n    transition:\n      transform 1s cubic-bezier(0.45, 0, 0.1, 1),\n      opacity 0.8s ease;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    position: static;\n    padding: 0;\n  "], ["\n    position: static;\n    padding: 0;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-width: initial;\n  "], ["\n    width: 100%;\n    max-width: initial;\n  "]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject, (0, _constants.getOuterSpace)("padding"), _constants.media.md(_templateObject2), _constants.colors.red500, _constants.fonts.tall, _constants.media.md(_templateObject3));

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmailMe = __webpack_require__(57);
	
	var _EmailMe2 = _interopRequireDefault(_EmailMe);
	
	var _style = __webpack_require__(156);
	
	var _SubscribeForm = __webpack_require__(104);
	
	var _SubscribeForm2 = _interopRequireDefault(_SubscribeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu() {
	  return _react2.default.createElement(
	    _style.Wrapper,
	    null,
	    _react2.default.createElement(
	      _style.NavItem,
	      { className: "col-start-2" },
	      _react2.default.createElement(_EmailMe2.default, { text: "Email" })
	    ),
	    _react2.default.createElement(
	      _style.NavItem,
	      null,
	      _react2.default.createElement(
	        "a",
	        {
	          href: "https://www.facebook.com/nausicaamusic/",
	          rel: "noopener noreferrer",
	          target: "_blank"
	        },
	        "Facebook"
	      )
	    ),
	    _react2.default.createElement(
	      _style.NavItem,
	      null,
	      _react2.default.createElement(_SubscribeForm2.default, null)
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports["default"];

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NavLink = exports.NavItem = exports.Nav = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: repeat(1, 1fr);\n\n  grid-gap: 1rem;\n  padding: 1rem;\n  ", "\n  ", "\n\n\n  li {\n    a {\n      transition: color 0.4s ease;\n      will-change: color;\n      position: relative;\n\n      &:hover {\n        color: #fff;\n\n        &::before {\n          transform: translate(0, -50%);\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  ", "\n"], ["\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  grid-template-rows: repeat(1, 1fr);\n\n  grid-gap: 1rem;\n  padding: 1rem;\n  ", "\n  ", "\n\n\n  li {\n    a {\n      transition: color 0.4s ease;\n      will-change: color;\n      position: relative;\n\n      &:hover {\n        color: #fff;\n\n        &::before {\n          transform: translate(0, -50%);\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 3rem;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(1, 1fr);\n  "], ["\n  padding: 3rem;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(1, 1fr);\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(1, 1fr);\n    padding: 1.5rem;\n    display: block;\n  "], ["\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(1, 1fr);\n    padding: 1.5rem;\n    display: block;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n\n  "], ["\n\n  "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  grid-column: 2 / span 4;\n\n  ", "\n"], ["\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  grid-column: 2 / span 4;\n\n  ", "\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  padding: 0.5rem 0;\n  line-height: 1em;\n\n  &.col-start-2 {\n    grid-column-start: 2;\n    ", "\n  }\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  a {\n    font-size: 0.9rem;\n    font-family: ", ";\n    pointer-events: all;\n    transition: color 0.1s ease;\n    line-height: 1em;\n    ", "\n  }\n"], ["\n  list-style: none;\n  padding: 0.5rem 0;\n  line-height: 1em;\n\n  &.col-start-2 {\n    grid-column-start: 2;\n    ", "\n  }\n\n  &:last-child {\n    padding-bottom: 0;\n  }\n\n  a {\n    font-size: 0.9rem;\n    font-family: ", ";\n    pointer-events: all;\n    transition: color 0.1s ease;\n    line-height: 1em;\n    ", "\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n    grid-column-start: 1;\n  "], ["\n    grid-column-start: 1;\n  "]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n            color: ", ";\n\n            &:hover::before {\n              display: none !important;\n            }\n          "], ["\n            color: ", ";\n\n            &:hover::before {\n              display: none !important;\n            }\n          "]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n            color: ", ";\n          "], ["\n            color: ", ";\n          "]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  &.active {\n    color: #fff;\n\n    &::before {\n      transform: translate(0, -50%);\n      opacity: 1;\n    }\n  }\n"], ["\n  &.active {\n    color: #fff;\n\n    &::before {\n      transform: translate(0, -50%);\n      opacity: 1;\n    }\n  }\n"]);
	
	var _gatsbyLink = __webpack_require__(52);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.nav(_templateObject, _constants.media.md(_templateObject2), _constants.media.sm(_templateObject3), _constants.media.md(_templateObject4));
	
	var Nav = exports.Nav = _styledComponents2.default.ul(_templateObject5, _constants.media.md(_templateObject4));
	
	var NavItem = exports.NavItem = _styledComponents2.default.li(_templateObject6, _constants.media.md(_templateObject7), _constants.fonts.mono, function (props) {
	  return props.highlight ? (0, _styledComponents.css)(_templateObject8, _constants.colors.red500) : (0, _styledComponents.css)(_templateObject9, _constants.colors.gray500);
	});
	
	var NavLink = exports.NavLink = (0, _styledComponents2.default)(_gatsbyLink2.default).attrs({
	  activeClassName: "active"
	})(_templateObject10);

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Logo = __webpack_require__(154);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Footer = __webpack_require__(102);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Menu = __webpack_require__(103);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ToggleMenu = __webpack_require__(163);
	
	var _ToggleMenu2 = _interopRequireDefault(_ToggleMenu);
	
	var _style = __webpack_require__(158);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Navigation.prototype.render = function render() {
	    return _react2.default.createElement(
	      _style.Wrapper,
	      null,
	      _react2.default.createElement(
	        _style.Shoable,
	        null,
	        _react2.default.createElement(_Logo2.default, null)
	      )
	    );
	  };
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	module.exports = exports["default"];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Header = exports.Shoable = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    z-index: 10;\n  "], ["\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    z-index: 10;\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    position: fixed;\n  "], ["\n    position: fixed;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  ", " ", ";\n"], ["\n  ", " ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    overflow: hidden;\n    transition: max-height .6s cubic-bezier(0.45, 0, .1, 1);\n    will-change: max-height;\n    margin-top: 1rem;\n    max-height: 200px;\n    \n    > div {\n      padding: 1.5rem 3rem 0.5rem;\n    }\n  "], ["\n    overflow: hidden;\n    transition: max-height .6s cubic-bezier(0.45, 0, .1, 1);\n    will-change: max-height;\n    margin-top: 1rem;\n    max-height: 200px;\n    \n    > div {\n      padding: 1.5rem 3rem 0.5rem;\n    }\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    > div {\n      padding: 0 1.5rem .5rem;\n    }\n  "], ["\n    > div {\n      padding: 0 1.5rem .5rem;\n    }\n  "]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  ", ";\n"], ["\n  ", ";\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    width: 100%;\n    min-height: 2rem;\n    ", ";\n    padding-bottom: 1rem !important;\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    width: 100%;\n    min-height: 2rem;\n    ", ";\n    padding-bottom: 1rem !important;\n  "]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject, _constants.media.md(_templateObject2), _constants.media.sm(_templateObject3));
	
	var Shoable = exports.Shoable = _styledComponents2.default.div(_templateObject4, _constants.media.md(_templateObject5), _constants.media.sm(_templateObject6));
	
	var Header = exports.Header = _styledComponents2.default.header(_templateObject7, _constants.media.md(_templateObject8, (0, _constants.getOuterSpace)("padding")));

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _style = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var encode = function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + "=" + encodeURIComponent(data[key]);
	  }).join("&");
	};
	
	var SubscribeForm = function (_React$Component) {
	  _inherits(SubscribeForm, _React$Component);
	
	  function SubscribeForm(props) {
	    _classCallCheck(this, SubscribeForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      formValues: {
	        email: "",
	        "bot-field": ""
	      },
	      status: "idle"
	    };
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  SubscribeForm.prototype.handleChange = function handleChange(event) {
	    var _event$target = event.target,
	        name = _event$target.name,
	        value = _event$target.value;
	
	    this.setState(function (prevState) {
	      var _extends2;
	
	      return {
	        formValues: _extends({}, prevState.formValues, (_extends2 = {}, _extends2[name] = value, _extends2))
	      };
	    });
	  };
	
	  SubscribeForm.prototype.handleSubmit = function handleSubmit(event) {
	    var _this2 = this;
	
	    event.preventDefault();
	
	    var _state = this.state,
	        status = _state.status,
	        formValues = _state.formValues;
	    var formName = this.props.formName;
	
	
	    if (!formValues.email || status === "submitting") {
	      return;
	    }
	
	    this.setState({ status: "submitting" });
	
	    fetch("/", {
	      method: "POST",
	      headers: { "Content-Type": "application/x-www-form-urlencoded" },
	      body: encode(_extends({
	        "form-name": formName
	      }, formValues))
	    }).then(function () {
	      _this2.setState({
	        status: "success",
	        formValues: {
	          email: "",
	          "bot-field": ""
	        }
	      });
	    }).catch(function () {
	      _this2.setState({ status: "error" });
	    });
	  };
	
	  SubscribeForm.prototype.render = function render() {
	    var _state2 = this.state,
	        formValues = _state2.formValues,
	        status = _state2.status;
	    var formName = this.props.formName;
	
	
	    return _react2.default.createElement(
	      _style.Section,
	      null,
	      _react2.default.createElement(
	        _style.FormCard,
	        {
	          name: formName,
	          method: "POST",
	          "data-netlify": "true",
	          "data-netlify-honeypot": "bot-field",
	          onSubmit: this.handleSubmit
	        },
	        _react2.default.createElement("input", { type: "hidden", name: "form-name", value: formName }),
	        _react2.default.createElement(
	          _style.Honeypot,
	          { "aria-hidden": "true" },
	          _react2.default.createElement(
	            "label",
	            null,
	            "Don\u2019t fill this out if you\u2019re human:",
	            _react2.default.createElement("input", {
	              name: "bot-field",
	              onChange: this.handleChange,
	              value: formValues["bot-field"],
	              tabIndex: "-1"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _style.Title,
	          null,
	          "Subscribe for updates"
	        ),
	        _react2.default.createElement(_style.Input, {
	          id: "subscribe-email",
	          name: "email",
	          type: "email",
	          placeholder: "email address",
	          autoComplete: "email",
	          value: formValues.email,
	          onChange: this.handleChange,
	          required: true
	        }),
	        _react2.default.createElement(
	          _style.Button,
	          { type: "submit", disabled: status === "submitting" },
	          status === "submitting" ? "Sending…" : "Subscribe"
	        ),
	        status === "success" && _react2.default.createElement(
	          _style.Message,
	          { role: "status" },
	          "\u2705 Submitted"
	        ),
	        status === "error" && _react2.default.createElement(
	          _style.Message,
	          { role: "alert" },
	          "Something went wrong. Please try again."
	        )
	      )
	    );
	  };
	
	  return SubscribeForm;
	}(_react2.default.Component);
	
	SubscribeForm.propTypes = {
	  formName: _propTypes2.default.string
	};
	
	SubscribeForm.defaultProps = {
	  formName: "subscribe"
	};
	
	exports.default = SubscribeForm;
	module.exports = exports["default"];

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Honeypot = exports.Message = exports.Button = exports.Input = exports.Label = exports.Title = exports.FormCard = exports.Section = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  ", "\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n\n  "], ["\n\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n\n  & > * + * {\n  }\n"], ["\n  ", "\n\n  ", "\n\n  & > * + * {\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  margin-top: 0.5rem;\n  padding: 0.7rem 0.9rem;\n  background: transparent;\n  border: 1px solid ", ";\n  width: 100%;\n  color: ", ";\n  font-family: ", ";\n  transition:\n    border-color 0.2s ease,\n    color 0.2s ease;\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  margin-top: 0.5rem;\n  padding: 0.7rem 0.9rem;\n  background: transparent;\n  border: 1px solid ", ";\n  width: 100%;\n  color: ", ";\n  font-family: ", ";\n  transition:\n    border-color 0.2s ease,\n    color 0.2s ease;\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  margin-top: 0.5rem;\n  border: none;\n  background: transparent;\n  color: ", ";\n  border: ", " solid 1px;\n  font-family: ", ";\n  padding: 0.75rem 1.5rem;\n  align-self: flex-start;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition:\n    transform 0.2s ease,\n    opacity 0.2s ease;\n\n  &:hover,\n  &:focus {\n    /*transform: translateY(-1px);*/\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: wait;\n    transform: none;\n  }\n"], ["\n  margin-top: 0.5rem;\n  border: none;\n  background: transparent;\n  color: ", ";\n  border: ", " solid 1px;\n  font-family: ", ";\n  padding: 0.75rem 1.5rem;\n  align-self: flex-start;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition:\n    transform 0.2s ease,\n    opacity 0.2s ease;\n\n  &:hover,\n  &:focus {\n    /*transform: translateY(-1px);*/\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: wait;\n    transform: none;\n  }\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  margin: 1rem 0 0 0;\n"], ["\n  color: ", ";\n  margin: 1rem 0 0 0;\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: -9999px;\n  opacity: 0;\n  height: 0;\n  width: 1px;\n  overflow: hidden;\n"], ["\n  position: absolute;\n  left: -9999px;\n  opacity: 0;\n  height: 0;\n  width: 1px;\n  overflow: hidden;\n"]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Section = exports.Section = _styledComponents2.default.section(_templateObject, _constants.media.md(_templateObject2), _constants.media.sm(_templateObject2));
	
	var FormCard = exports.FormCard = _styledComponents2.default.form(_templateObject3, _constants.media.md(_templateObject2), _constants.media.sm(_templateObject2));
	
	var Title = exports.Title = _styledComponents2.default.a(_templateObject4);
	
	var Label = exports.Label = _styledComponents2.default.label(_templateObject4);
	
	var Input = exports.Input = _styledComponents2.default.input(_templateObject5, _constants.colors.gray500, _constants.colors.gray500, _constants.fonts.mono, _constants.colors.red500, _constants.colors.gray500);
	
	var Button = exports.Button = _styledComponents2.default.button(_templateObject6, _constants.colors.red500, _constants.colors.red500, _constants.fonts.mono);
	
	var Message = exports.Message = _styledComponents2.default.p(_templateObject7, _constants.colors.gray500);
	
	var Honeypot = exports.Honeypot = _styledComponents2.default.p(_templateObject8);

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleMenu = function ToggleMenu(props) {
	  return _react2.default.createElement(
	    _style.Wrapper,
	    props,
	    'Menu'
	  );
	};
	
	exports.default = ToggleMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: none;\n  height: 15px;\n  width: 1.75rem;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  backface-visibility: hidden;\n  transition: transform .45s cubic-bezier(.45, 0, .07, 1);\n  will-change: transform;\n\n  span {\n    display: inline-block;\n    height: 1px;\n    background: #fff;\n  }\n  \n  ', '\n'], ['\n  display: none;\n  height: 15px;\n  width: 1.75rem;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-end;\n  backface-visibility: hidden;\n  transition: transform .45s cubic-bezier(.45, 0, .07, 1);\n  will-change: transform;\n\n  span {\n    display: inline-block;\n    height: 1px;\n    background: #fff;\n  }\n  \n  ', '\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    display: flex;\n  '], ['\n    display: flex;\n  ']);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = exports.Wrapper = _styledComponents2.default.div(_templateObject, _constants.media.md(_templateObject2));

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.NauTall = exports.NauWeb = undefined;
	
	var _nauWebTitle = __webpack_require__(282);
	
	var _nauWebTitle2 = _interopRequireDefault(_nauWebTitle);
	
	var _nauWebTall = __webpack_require__(281);
	
	var _nauWebTall2 = _interopRequireDefault(_nauWebTall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// src/fonts/index.js
	
	exports.NauWeb = _nauWebTitle2.default;
	exports.NauTall = _nauWebTall2.default;

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nau-web-tall.990842e2.woff2";

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nau-web-title.59e21651.woff2";

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Navigation = __webpack_require__(157);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Menu = __webpack_require__(103);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(102);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _SubscribeForm = __webpack_require__(104);
	
	var _SubscribeForm2 = _interopRequireDefault(_SubscribeForm);
	
	__webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children,
	      location = _ref.location;
	  return _react2.default.createElement(
	    "main",
	    null,
	    _react2.default.createElement(_Navigation2.default, { location: location }),
	    children(),
	    _react2.default.createElement(_Menu2.default, null)
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n\n  @font-face {\n    font-family: 'nau-web-title';\n    font-style: normal;\n    font-weight: bold;\n    src: local('nau-web-title'), url('", "') format('woff2');\n  }\n\n  @font-face {\n    font-family: 'nau-web-tall';\n    src: local('nau-web-tall'), url('", "') format('woff2');\n    font-weight: 200;\n  }\n\n  @font-face {\n    font-family: stack-mono;\n    font-style: normal;\n    font-weight: 300;\n    src: local(\".SFMono-Regular\"), local(\".Consolas\"), local(\".Liberation Mono\"), local(\"Menlo\"), local(\"Courier\"), local(\"monospace\");\n  }\n\n  @font-face {\n    font-family: stack;\n    font-style: normal;\n    font-weight: 300;\n    src: local(\".SFNSText-Light\"), local(\".HelveticaNeueDeskInterface-Light\"), local(\".LucidaGrandeUI\"), local(\"Ubuntu Light\"), local(\"Segoe UI Light\"), local(\"Roboto-Light\"), local(\"DroidSans\"), local(\"Tahoma\");\n  }\n\n  html, body {\n    height: 100%;\n    font-size: 16px;\n    ", "\n  }\n\n  body {\n    background: ", ";\n    color: #fff;\n    font-family: ", ";\n    backface-visibility: hidden;\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    font-family: ", ";\n    font-weight: bold;\n    line-height: inherit;\n  }\n\n  a {\n    color: inherit;\n    text-decoration: none;\n    transition: color ease-in .2s;\n\n    &:hover {\n      color: #fff;\n    }\n  }\n\n  * {\n    box-sizing: border-box;\n    line-height: 1.4em;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-kerning: auto;\n  }\n\n  ::selection {\n    color: ", ";\n    background: transparent;\n  }\n\n  .custom-player-btn {\n    color: white !important;\n    padding: 0 0.5rem 0.2rem 0.5rem !important;\n    font-size: .8rem !important;\n  }\n  .timer-wrap {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .events {\n    margin-top: 3rem;\n    h2 {\n      font-size: 1.2rem;\n      margin-bottom:1.2rem;\n    }\n    h3 {\n      font-size: 1rem;\n      margin-bottom:1.2rem;\n    }\n    p {\n      font-size: 0.9rem;\n      color: #e3e3e3;\n    }\n    .past {\n      opacity: 0.7;\n      margin-top: 3rem;\n    }\n  }\n"], ["\n  ", "\n\n  @font-face {\n    font-family: 'nau-web-title';\n    font-style: normal;\n    font-weight: bold;\n    src: local('nau-web-title'), url('", "') format('woff2');\n  }\n\n  @font-face {\n    font-family: 'nau-web-tall';\n    src: local('nau-web-tall'), url('", "') format('woff2');\n    font-weight: 200;\n  }\n\n  @font-face {\n    font-family: stack-mono;\n    font-style: normal;\n    font-weight: 300;\n    src: local(\".SFMono-Regular\"), local(\".Consolas\"), local(\".Liberation Mono\"), local(\"Menlo\"), local(\"Courier\"), local(\"monospace\");\n  }\n\n  @font-face {\n    font-family: stack;\n    font-style: normal;\n    font-weight: 300;\n    src: local(\".SFNSText-Light\"), local(\".HelveticaNeueDeskInterface-Light\"), local(\".LucidaGrandeUI\"), local(\"Ubuntu Light\"), local(\"Segoe UI Light\"), local(\"Roboto-Light\"), local(\"DroidSans\"), local(\"Tahoma\");\n  }\n\n  html, body {\n    height: 100%;\n    font-size: 16px;\n    ", "\n  }\n\n  body {\n    background: ", ";\n    color: #fff;\n    font-family: ", ";\n    backface-visibility: hidden;\n  }\n\n  h1, h2, h3, h4, h5, h6 {\n    font-family: ", ";\n    font-weight: bold;\n    line-height: inherit;\n  }\n\n  a {\n    color: inherit;\n    text-decoration: none;\n    transition: color ease-in .2s;\n\n    &:hover {\n      color: #fff;\n    }\n  }\n\n  * {\n    box-sizing: border-box;\n    line-height: 1.4em;\n    text-rendering: optimizeLegibility;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-kerning: auto;\n  }\n\n  ::selection {\n    color: ", ";\n    background: transparent;\n  }\n\n  .custom-player-btn {\n    color: white !important;\n    padding: 0 0.5rem 0.2rem 0.5rem !important;\n    font-size: .8rem !important;\n  }\n  .timer-wrap {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .events {\n    margin-top: 3rem;\n    h2 {\n      font-size: 1.2rem;\n      margin-bottom:1.2rem;\n    }\n    h3 {\n      font-size: 1rem;\n      margin-bottom:1.2rem;\n    }\n    p {\n      font-size: 0.9rem;\n      color: #e3e3e3;\n    }\n    .past {\n      opacity: 0.7;\n      margin-top: 3rem;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n      font-size: 14px;\n    "], ["\n      font-size: 14px;\n    "]);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledReset = __webpack_require__(365);
	
	var _styledReset2 = _interopRequireDefault(_styledReset);
	
	var _constants = __webpack_require__(4);
	
	var _fonts = __webpack_require__(173);
	
	var webfonts = _interopRequireWildcard(_fonts);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	(0, _styledComponents.injectGlobal)(_templateObject, _styledReset2.default, webfonts.NauWeb, webfonts.NauTall, _constants.media.xl(_templateObject2), _constants.colors.blue900, _constants.fonts.mono, _constants.fonts.title, _constants.colors.red500);

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-a6bf6b085fcda10de536.js